import { AfterContentChecked, ChangeDetectorRef, Directive, DoCheck, ElementRef, HostListener, NgZone, input } from "@angular/core";

@Directive({
    "selector": "[dragSource]",
    standalone: true
})
export class DragSourceDirective implements DoCheck {
    readonly dragSource = input<any>(undefined);
    readonly dragEnabled = input<boolean>(true);
    readonly targetsSelector = input<string>(undefined);
    readonly sourceSelector = input<string>(undefined);
    readonly selectedItems = input<any[]>(undefined);
    readonly effect = input<string>("move");
    readonly showPreview = input(true);
    readonly enableScroll = input(true);

    constructor (private el: ElementRef, private ngZone: NgZone, public cd: ChangeDetectorRef) { }

    ngDoCheck () : void {
        const sourceSelector = this.sourceSelector();
        if (!sourceSelector) {
            this.el.nativeElement.setAttribute("draggable", true);
        } else {
            this.cd.detectChanges();
            this.el.nativeElement.querySelectorAll("[draggable]").forEach((item: any) => item.removeAttribute("draggable"));
            this.cd.detectChanges();
            let els = this.el.nativeElement.querySelectorAll(sourceSelector);
            els.forEach((item: any) => {
                item.setAttribute("draggable", true);
            });
        }
    }

    @HostListener("dragstart", ["$event"])
    onDragStart (event: any) {
        if (!this.dragEnabled()) { return; }

        let elems = document.querySelectorAll(this.targetsSelector());
        for (let i = 0; i < elems.length; i++) {
            elems[i].classList.add("drag-active");
            elems[i].classList.remove("over");
        }

        event.dataTransfer.effectAllowed = this.effect();
        const selectedItems = this.selectedItems();
        if (!selectedItems) {
            event.dataTransfer.setData("text", JSON.stringify([this.dragSource()]));
        } else {
            event.dataTransfer.setData("text", JSON.stringify(selectedItems));
        }

        if (typeof event.dataTransfer.setDragImage !== "undefined" && !this.showPreview()) {
            let container = document.createElement("span");
            container.id = "drag-image";
            event.dataTransfer.setDragImage(container, 0, 0);
        }

        if (this.enableScroll()) {
            this.ngZone.runOutsideAngular(() => {
                let body = document.querySelector("body");
                let topScrollZone = document.createElement("div");
                topScrollZone.id = "scroll-top";
                topScrollZone.innerHTML = "<i class=\"fas fa-chevron-up fa-2x\"></i>";
                topScrollZone.addEventListener("dragover", (evt) => {
                    window.scrollBy(0, -10);
                });

                body.appendChild(topScrollZone);
                let bottomScrollZone = document.createElement("div");
                bottomScrollZone.id = "scroll-bottom";
                bottomScrollZone.innerHTML = "<i class=\"fas fa-chevron-down fa-2x\"></i>";
                bottomScrollZone.addEventListener("dragover", (evt) => {
                    window.scrollBy(0, 10);
                });
                body.appendChild(bottomScrollZone);
            });
        }
    }

    @HostListener("dragend") onDragEnd (): void {
        let elems = document.querySelectorAll(this.targetsSelector());
        for (let i = 0; i < elems.length; i++) {
            elems[i].classList.remove("drag-active");
            elems[i].classList.remove("over");
        }

        let body = document.querySelector("body");
        let scrollTop = document.querySelector("#scroll-top");
        let scrollBottom = document.querySelector("#scroll-bottom");
        if (scrollTop) { body.removeChild(scrollTop); }
        if (scrollBottom) { body.removeChild(scrollBottom); }
    }
}
